/**
 * Mutación que sirve para activar el loader en la aplicación
 * @param {State} state Estado de Vue
 * @param {*} loaderMessage 
 */
export function loading(state, loaderMessage="Cargando..."){
    state.loaderMessage = loaderMessage;
    state.loaderVisible = true; 
}

/**
 * Mutación que sirve para descativar loader en la aplicación
 * @param {State} state Estado de Vue
 */
export function loaded(state){
    state.loaderMessage = 'Cargando...';
    state.loaderVisible = false; 
}